import { render } from "./MeasurementsForm.vue?vue&type=template&id=40969b79&scoped=true"
import script from "./MeasurementsForm.vue?vue&type=script&lang=js"
export * from "./MeasurementsForm.vue?vue&type=script&lang=js"

import "./MeasurementsForm.vue?vue&type=style&index=0&id=40969b79&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40969b79"]])

export default __exports__